import { NAV, SERVICES, FOOTER_CONTACT } from '../data/site.js';
import { scrollToId } from '../hooks/useActiveSection.js';
import clinicLogo from '../assets/images/clinicLogo.png';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <a
              href="#home"
              className="logo footer-logo"
              onClick={(e) => {
                e.preventDefault();
                scrollToId('home');
              }}
            >
              <img className="logo-img" src={clinicLogo} alt="Kanaga Dental Clinic" />
            </a>
            <p>
              Providing personalized dental care with compassion and expertise across two convenient
              locations.
            </p>
            <p className="footer-tagline">&ldquo;Your Smile, Our Priority&rdquo;</p>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              {NAV.map((n) => (
                <li key={n.id}>
                  <a
                    href={`#${n.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToId(n.id);
                    }}
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Dental Services</h4>
            <ul>
              {SERVICES.map((s) => (
                <li key={s.title}>
                  <a
                    href="#services"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToId('services');
                    }}
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              {FOOTER_CONTACT.map((c) => (
                <li key={c}>
                  <span>{c}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {year} Kanaga Dental Clinic. All rights reserved.</span>
          <span>Your Smile, Our Priority 🦷</span>
        </div>
      </div>
    </footer>
  );
}
